module.exports = __webpack_public_path__ + "9bcf055a732c0b22d2279ba79e20c577.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-italic-webfont.woff2
 ** module id = ./src/styles/fonts/lato/lato-italic-webfont.woff2
 ** module chunks = 0
 **/